import { HorizontalTabLayout } from '../../components'
import { getMessagesTabProps } from './constants'

type MessagesProps = {
  openTab: string
  showNews: boolean
}

export const Messages = ({ openTab, showNews }: MessagesProps) => {
  return (
    <HorizontalTabLayout
      openTab={openTab}
      tabProps={getMessagesTabProps(showNews)}
    />
  )
}
